/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import React from 'react';
import moment from 'moment';
import {useRouter} from 'next/router';

import Link from '../../components/Link';
import {RightArrowIcon} from '../../components/svg';
import {useAnalytics} from '../../hooks';

const ExperienceCard = ({experience, tag}) => {
  const {tracker} = useAnalytics();
  const router = useRouter();
  const slug = experience.slug || experience.id;
  const url = `/experiences/${slug}?returnPath=${encodeURIComponent(`/companies/${tag.id}`)}`;

  const handleClick = () => {
    tracker.hubClickCard({type: 'experiences', tag: tag.id, slug});
    router.push(url);
  };

  return (
    <div
      onClick={handleClick}
      className="cursor-pointer p-4 border border-gray-200 rounded-lg transition hover:border-gray-300 hover:bg-gray-50 flex flex-col justify-between"
    >
      <div className="mb-3">
        <Link href={url}>
          <h3 className="text-base font-semibold text-gray-900">
            {experience.jobTitle || experience.role_name}
          </h3>
        </Link>
        {experience.asked_on && (
          <span className="mt-0.5 block text-sm text-gray-500">
            {moment(experience.asked_on).format('MMM YYYY')}
          </span>
        )}
        {experience.snippet && (
          <p className="mt-2 text-sm leading-relaxed text-gray-600 line-clamp-3">
            &ldquo;
            {experience.snippet}
            &rdquo;
          </p>
        )}
      </div>
      <span className="mt-auto ml-auto inline-flex items-center text-sm font-medium text-indigo">
        View full interview
        <RightArrowIcon className="w-4 ml-1.5" />
      </span>
    </div>
  );
};

export default ExperienceCard;
